module.exports = __webpack_public_path__ + "img/notification-lightning.65f6c1fe.svg";